import { render, staticRenderFns } from "./sjq_jm.vue?vue&type=template&id=21678d80&"
import script from "./sjq_jm.vue?vue&type=script&lang=js&"
export * from "./sjq_jm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports